import { Injectable } from '@angular/core';
import { AlertButton, AlertController, AlertInput } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    private alertController: AlertController,
  ) {}

  async confirm(header: string, message: string, confirmButton: Pick<AlertButton, 'handler' | 'text' | 'role'>, cancelButton?: Pick<AlertButton, 'handler' | 'text'>): Promise<HTMLIonAlertElement> {
    const alert = await this.alertController.create({
      buttons: [
        {
          role: 'cancel',
          text: 'Cancelar',
          ...cancelButton,
        },
        {
          handler: confirmButton.handler,
          role: confirmButton.role ?? 'confirm',
          text: confirmButton.text ?? 'Confirmar',
        },
      ],
      header,
      message,
    });
    await alert.present();
    return alert;
  }

  async confirmInputs(
    header: string,
    message: string,
    confirmButton: Pick<AlertButton, 'handler' | 'text' | 'role'>,
    cancelButton?: Pick<AlertButton, 'handler' | 'text'>,
    inputs: AlertInput[] = [],
  ): Promise<HTMLIonAlertElement> {
    const alert = await this.alertController.create({
      buttons: [
        {
          role: 'cancel',
          text: 'Cancelar',
          ...cancelButton,
        },
        {
          handler: confirmButton.handler,
          role: confirmButton.role ?? 'confirm',
          text: confirmButton.text ?? 'Confirmar',
        },
      ],
      header,
      inputs,
      message,
    });
    await alert.present();
    return alert;
  }

  async confirmUnsavedChanges(saveAndExit: () => Promise<boolean>): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.alertController.create({
        buttons: [
          {
            cssClass: 'alert-button bold',
            handler: async () => {
              const saved = await saveAndExit();
              resolve(saved);
            },
            text: 'Guardar',
          },
          {
            handler: () => resolve(true),
            role: 'destructive',
            text: 'No guardar',
          },
          {
            cssClass: 'alert-button normal',
            handler: () => resolve(false),
            text: 'Cancelar',
          },
        ],
        header: '¿Deseas guardar antes de salir?',
        message: 'Todos los cambios realizados se perderán si no guardas',
      }).then((alert) => alert.present());
    });
  }
}
